function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c5c5c5;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M164.545,220.5H150.08a.748.748,0,0,1,0-1.5h14.465a.748.748,0,0,1,0,1.5Zm0,0",
  transform: "translate(-142.349 -208.775)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M154.078,143.13a.742.742,0,0,1-.529-.219l-3.99-3.99a.749.749,0,0,1,0-1.059l3.99-3.99a.748.748,0,0,1,1.059,1.058l-3.462,3.462,3.462,3.462a.748.748,0,0,1-.53,1.277Zm0,0",
  transform: "translate(-142.356 -127.418)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M10.974,22.279A10.974,10.974,0,1,1,21.187,7.291a.748.748,0,1,1-1.393.548,9.477,9.477,0,1,0,0,6.934.748.748,0,1,1,1.393.548,10.917,10.917,0,0,1-10.213,6.958Zm0,0",
  transform: "translate(0 -0.332)"
});

const SvgIconLogout = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.944,
    height: 21.947,
    viewBox: "0 0 22.944 21.947",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Logout.ddf99476.svg";
export { ForwardRef as ReactComponent };